export default __webpack_public_path__ + "static/logo-bg-5b0a3839cf4e5e6cc82ff3901d97fa02.png";